import { getDashboardSummary } from '@api/getDashboardSummary';
import { SummaryItemType } from '@type/dashboard';
import { useEffect, useState } from 'react';
import { useCustomParams } from './useCustomParams';
import { API_REFETCH_TIME } from '@containers/dashboard/options';

interface useDashboardSummaryType {
  summaryList: SummaryItemType[];
  isLoading: boolean;
}

export const useDashboardSummary = (): useDashboardSummaryType => {
  const [summaryList, setSummaryList] = useState<SummaryItemType[]>([]);

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [apiRefetch, setApiRefetch] = useState<boolean>(false);

  const { searchParams } = useCustomParams();

  const election_schedule_id = searchParams.get('election_schedule_id');

  useEffect(() => {
    setIsLoading(true);
    if (election_schedule_id) {
      getDashboardSummary(election_schedule_id)
        .then((res) => {
          setSummaryList(res?.data || []);
          setIsLoading(false);
        })
        .catch((err) => {
          setIsLoading(false);
        });
    } else {
      setIsLoading(false);
    }
  }, [apiRefetch, election_schedule_id]);

  useEffect(() => {
    const interval = setInterval(() => {
      setApiRefetch((prev) => !prev);
    }, API_REFETCH_TIME * 1000);

    return () => {
      setApiRefetch(false);
      clearInterval(interval);
    };
  }, []);

  return {
    summaryList,
    isLoading,
  };
};
